import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, Heart, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-purple-950 border-t border-purple-800 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="w-6 h-6 text-yellow-400" />
              <span className="text-xl font-bold text-white">
                Infused by <span className="text-yellow-400">Daizy</span>
              </span>
            </div>
            <p className="text-purple-300 text-sm leading-relaxed">
              Hand-crafted ritual oils and intention blends, charged with moon energy and anointed with sacred herbs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-purple-300 hover:text-white transition-colors text-sm">
                  Shop All Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-purple-300 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-purple-300 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-sm">
                <Mail className="w-4 h-4 text-yellow-400" />
                <a href="mailto:daizyinfused@gmail.com" className="text-purple-300 hover:text-white transition-colors">
                  daizyinfused@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <Instagram className="w-4 h-4 text-yellow-400" />
                <a 
                  href="https://www.instagram.com/infusedbydaizy?igsh=dmVnMXp4M2h2M2l2" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-purple-300 hover:text-white transition-colors"
                >
                  @infusedbydaizy
                </a>
              </div>
              <p className="text-purple-300 text-sm">
                Custom blends available upon request
              </p>
            </div>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center mb-6">
          <a 
            href="https://www.instagram.com/infusedbydaizy?igsh=dmVnMXp4M2h2M2l2" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-purple-800 hover:bg-purple-700 p-3 rounded-full transition-colors"
            aria-label="Follow us on Instagram"
          >
            <Instagram className="w-6 h-6 text-yellow-400" />
          </a>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-purple-800 pt-8 text-center">
          <p className="text-purple-300 text-sm flex items-center justify-center">
            Made with <Heart className="w-4 h-4 mx-1 text-yellow-400" /> by Infused by Daizy © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
